import { render, staticRenderFns } from "./AskAiInput.vue?vue&type=template&id=60690730&scoped=true"
import script from "./AskAiInput.vue?vue&type=script&lang=js"
export * from "./AskAiInput.vue?vue&type=script&lang=js"
import style0 from "./AskAiInput.vue?vue&type=style&index=0&id=60690730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60690730",
  null
  
)

export default component.exports